import { render, staticRenderFns } from "./PartnerSection.vue?vue&type=template&id=56cb9003"
import script from "./PartnerSection.vue?vue&type=script&lang=js"
export * from "./PartnerSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports